import React, { useEffect, useState } from "react";
import {
  Configuration,
  CustomerContactData,
  MapApiKeys,
} from "../Types/Configuration";
import "./Homepage.css";
import IconMenu from "./IconMenu";
import CarViewer from "./CarViewer";
import NewsMenu from "./NewsMenu";
import { apiBaseUrl, imageServerUrl, imageSizes } from "../../constants/config";
import PersonsList from "./PersonsList";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import axios from "axios";
interface HomepageProps {
  homepageConfig: Configuration["homepage"];
  loading: boolean;
  contactData: CustomerContactData;
}
const Homepage: React.FC<HomepageProps> = ({
  homepageConfig,
  loading,
  contactData,
}) => {
  const location = {
    lat: parseFloat(contactData.latitude ?? "0") || 0,
    lng: parseFloat(contactData.longitude ?? "0") || 0,
  };

  const [mapKeys, setMapKeys] = useState<MapApiKeys | null>(null);
  useEffect(() => {
    fetchMapKeys();
  }, []);
  const fetchMapKeys = async () => {
    try {
      const response = await axios.get<MapApiKeys>(
        `${apiBaseUrl}/map-api-keys`,
      );
      setMapKeys(response.data);
    } catch (error) {
      console.error("Error fetching map API keys:", error);
    }
  };
  return (
    <>
      {/* Header Section */}
      {loading ? (
        <>
          <div className="loading-header-skeleton"></div>
          <div className="loading-header-container">
            <div className="loading"></div>
          </div>
        </>
      ) : (
        <header>
          <img
            className="header-image"
            src={`${imageServerUrl}/image/${imageSizes.large}/${homepageConfig.header.headerImageUrl}`}
            alt=""
          />
          <div className="background-overlay"></div>
          <div className="header-text-container">
            <h1>{homepageConfig.header.headerText}</h1>
            <h2> {homepageConfig.header.subHeaderText}</h2>
          </div>
        </header>
      )}
      <CarViewer isLoading={loading} />
      {/* Item Menu 1 Section */}
      <IconMenu iconMenu={homepageConfig.iconMenu || []} isLoading={loading} />

      {/* Item Menu 2 Section */}
      <NewsMenu newsMenu={homepageConfig.newsMenu || []} isLoading={loading} />
      {/* People Section */}
      <PersonsList people={homepageConfig.team || []} isLoading={loading} />

      {mapKeys?.mapApiKey && location.lat !== 0 && location.lng !== 0 && (
        <div className="map-container">
          <APIProvider apiKey={mapKeys.mapApiKey}>
            <Map
              id={mapKeys.mapId || "my-static-map"}
              defaultCenter={location}
              defaultZoom={15}
              className="map"
              gestureHandling="greedy"
              disableDefaultUI={false}
            >
              <Marker position={location} />
            </Map>
          </APIProvider>
        </div>
      )}
    </>
  );
};

export default Homepage;
